/*******************************************************************************
GET RUMOR UPDATES
Returns a set of updates.
*******************************************************************************/

import showErrorNotificationBar from '../../universal/error-handling/show-error-notification-bar';
import removeButtonProcessingState from '../../universal/button-state/remove-button-processing-state';
import switchToggleTab from '../../universal/toggle-tabs/switch-tab';

export default async function getRumors(e) {
    const $showMoreButton = $(e.currentTarget);

    // Options on Show More button
    const sport = String($showMoreButton.data('sport') || '').toLowerCase();
    const type = String($showMoreButton.data('type') || '').toLowerCase();
    const itemID = $showMoreButton.data('item-id') || '';
    const lastUpdateTime = $showMoreButton.data('last-update-time') || '';
    const numUpdates = $showMoreButton.data('num-updates') || '';
    const team = String($showMoreButton.data('team') || '').toLowerCase();
    const position = String($showMoreButton.data('position') || '').toLowerCase();
    const status = String($showMoreButton.data('status') || '').toLowerCase();
    const leagueLevel = String($showMoreButton.data('leaguelevel') || '');
    //const priority = $showMoreButton.data('priority') || '';
    const rank = $showMoreButton.data('rank') || '';
    const offense = $showMoreButton.data('offense') || false;
    const top = $showMoreButton.data('top') || false;
    const idp = $showMoreButton.data('idp') || false;
    const teamDef = $showMoreButton.data('teamdef') || false;
    const freeAgents = $showMoreButton.data('free-agents') || false;
    const hideLogo = $showMoreButton.data('hide-logo') || false;
    const conferenceVal = $showMoreButton.data('conference');
    const conference = (conferenceVal || conferenceVal === 0) ? conferenceVal : '';
    const league = $showMoreButton.data('league') || '';
    const competition = $showMoreButton.data('competition') || '';
    const nation = $showMoreButton.data('nation') || '';
    const nlonly = $showMoreButton.data('nlonly') || '';
    const alonly = $showMoreButton.data('alonly') || '';
    const closers = $showMoreButton.data('closers') || '';
    const minors = $showMoreButton.data('minors') || '';
    const prospects = $showMoreButton.data('prospects') || '';
    //const injuries = $showMoreButton.data('injuries') || '';
    const gender = $showMoreButton.data('gender') || '';
    const foreign = $showMoreButton.data('foreign') || '';
    const language = $showMoreButton.data('language') || '';
    const extraClasses = $showMoreButton.data('extra-classes') || '';

    // Add the options that were set on the button
    const settings = {};
    if (type) { settings.type = type; }
    if (itemID) { settings.itemID = itemID; }
    if (lastUpdateTime) { settings.lastUpdateTime = lastUpdateTime; }
    if (numUpdates) { settings.numUpdates = numUpdates; }
    if (team) { settings.team = team; }
    if (position) { settings.position = position; }
    if (status) { settings.status = status; }
    if (leagueLevel) { settings.leagueLevel = leagueLevel; }
    //if (priority) { settings.priority = priority; }
    if (rank) { settings.rank = rank; }
    if (offense) { settings.offense = offense; }
    if (top) { settings.top = top; }
    if (idp) { settings.idp = idp; }
    if (teamDef) { settings.teamDef = teamDef; }
    if (freeAgents) { settings.freeAgents = freeAgents; }
    if (hideLogo) { settings.hideLogo = hideLogo; }
    if (conference !== '') { settings.conference = conference; }
    if (league) { settings.league = league; }
    if (competition) { settings.competition = competition; }
    if (nation) { settings.nation = nation; }
    if (nlonly) { settings.nlonly = nlonly; }
    if (alonly) { settings.alonly = alonly; }
    if (closers) { settings.closers = closers; }
    if (minors) { settings.minors = minors; }
    if (prospects) { settings.prospects = prospects; }
    //if (injuries) { settings.injuries = injuries; }
    if (gender) { settings.gender = gender; }
    if (foreign) { settings.foreign = foreign; }
    if (language) { settings.language = language; }
    if (extraClasses) { settings.extraClasses = extraClasses; }

    const sportDirectories = {
        //cbb: 'cbasketball',
        //cfb: 'cfootball',
        mlb: 'baseball',
        nba: 'basketball',
        //nfl: 'football',
        nhl: 'hockey',
        //pga: 'golf',
        //cri: 'cricket',
        //soc: 'soccer',
    };
    const sportDirectory = sportDirectories[sport.toLowerCase()] || sport;

    try {
        const response = await $.ajax({
            type   : 'GET',
            url    : `/${sportDirectory}/ajax/get-more-rumors.php`,
            data   : settings,
            timeout: 8000,
        });

        const { updatesHTML, newLastUpdateTime, noMoreUpdates, success } = response;

        // Check for errors with the data
        if (response.error || !success) { throw new Error(response.error); }

        $showMoreButton.data('last-update-time', newLastUpdateTime);
        $showMoreButton.before(updatesHTML);
        if (noMoreUpdates) {
            $showMoreButton.after('<p class="light">There are no more news updates to display.</p>');
            $showMoreButton.remove();
        }

        // If there are toggle tabs in use on the news page, perform the active
        // toggle's actions on the news updates that were just added to the page
        if ($('.toggle-tabs').length > 0) {
            const $activeToggleTab = $('.toggle-tab.is-selected');
            const activeToggleTabName = $activeToggleTab.data('name');
            const activeToggleTabSetName = $activeToggleTab.parents('.toggle-tabs').data('name');
            if (activeToggleTabSetName && activeToggleTabName) {
                switchToggleTab(activeToggleTabSetName, activeToggleTabName);
            }
        }

    }
    catch (error) {
        showErrorNotificationBar(error.message || 'We were unable to retrieve updates for you. Please try again.', 3000);
    }

    // Reset the button to its original state
    removeButtonProcessingState($showMoreButton);

}
